import React from 'react'
import ArticleField from '../ArticleField';
import { TextField } from '@material-ui/core';

interface SurTitleProps {
    value: string,
    onChange: (value: string) => void
}

const SurTitle = (props: SurTitleProps) => (
    <ArticleField>
        <TextField
            inputProps={{ maxLength: 256 }}
            fullWidth={true} label="Surtitre"
            multiline
            value={props.value} onChange={(e) => {
                props.onChange(e.target.value);
            }} />
        {props.value.length}/256
    </ArticleField>
);

export default SurTitle;